import React from "react";
import { NavLink, Link } from "react-router-dom";

// icons
import IataIcon from "react-icons/lib/md/landscape";
// import PdmDataEntry from 'react-icons/lib/fa/cloud-upload';
import PdmReport from "react-icons/lib/fa/edit";
// import UploadIcon from 'react-icons/lib/md/cloud-upload';
import ReportsIcon from "react-icons/lib/md/insert-chart";
import ProformaIcon from "react-icons/lib/md/bubble-chart";
import IconSearch from "react-icons/lib/md/search";
import TSCIcon from "react-icons/lib/ti/clipboard";
import PaymentReconciliation from "react-icons/lib/fa/wpforms";
import InvoiceIcon from "react-icons/lib/md/receipt";
import IconDashboard from "react-icons/lib/md/dashboard";
import HelpIcon from "react-icons/lib/md/help-outline";
import TicketSearch from "react-icons/lib/md/question-answer"
import FlightOperationIcon from "react-icons/lib/md/flight"
import PassengerIcon from "react-icons/lib/md/date-range"


const VGGUserMenuComponent = ({
  handleClick,
  selected,
  handleOpen,
  handleDataEntry,
}) => {
  return (
    <ul className="list-unstyled mt-3 nav-list clearfix">
      <li
        onClick={handleClick.bind(this, 0)}
        className={selected === 0 ? "selected" : ""}
      >
        <Link to="/">
          <IconDashboard size="18" />
          <span className="name">DashBoard</span>
        </Link>
      </li>
      <li
        onClick={handleClick.bind(this, 30)}
        className={selected === 30 ? "selected" : ""}
      >
        <NavLink to="/search" activeClassName="active">
          <IconSearch size="18" />
          <span className="name">
            Manifest
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 4)}
        className={selected === 4 ? "selected" : ""}
      >
        <NavLink to="/iata" activeClassName="active">
          <IataIcon size="18" className="icon-flight-takeoff" />
          <span className="name">Iata Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 8)}
        className={selected === 8 ? "selected" : ""}
      >
        <NavLink to="/invoice" activeClassName="active">
          <InvoiceIcon size="18" />
          <span className="name">
            Invoice
            <br /> Reconciliation
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 5)}
        className={selected === 5 ? "selected" : ""}
      >
        <NavLink to="/tsc" activeClassName="active">
          <TSCIcon size="18" className="icon-clipboard" />
          <span className="name">TSC Statement</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 11)}
        className={selected === 11 ? "selected" : ""}
      >
        <NavLink to="/reports" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">Reports</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 12)}
        className={selected === 12 ? "selected" : ""}
      >
        <NavLink to="/proforma" activeClassName="active">
          <ProformaIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Proforma
            <br /> Report
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 13)}
        className={selected === 13 ? "selected" : ""}
      >
        <NavLink to="/payment-reconciliation" activeClassName="active">
          <PaymentReconciliation size="18" className="icon-Wpforms" />
          <span className="name">
            Payment
            <br /> Reconciliation
          </span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 50)}
        className={selected === 50 ? "selected" : ""}
      >
        <NavLink to="/pdm-report" activeClassName="active">
          <PdmReport size="18" className="FaEdit" />
          <span className="name">PDM Report</span>
        </NavLink>
      </li>
      <li
        onClick={handleClick.bind(this, 60)}
        className={selected === 60 ? "selected" : ""}
      >
        <NavLink to="/billed-per-airport" activeClassName="active">
          <ReportsIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Billed per <br /> Airport
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/ticket-search" activeClassName="active">
          <TicketSearch size="18" />
          <span className="name">
            Search By
            <br /> Ticket
          </span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/flight-operations" activeClassName="active">
          <FlightOperationIcon size="18" className="icon-insert-chart" />
          <span className="name">
            Flight <br /> Operations
          </span>
        </NavLink>
      </li>
      <li
      >
        <NavLink to="/passenger-level-data" activeClassName="active">
          <PassengerIcon size="18" className="icon-insert-chart" />
          <span className="name">
           Passenger level <br /> Data
          </span>
        </NavLink>
      </li>
      <hr></hr>

      <li
        onClick={handleClick.bind(this, 68)}
        className={selected === 68 ? "selected" : ""}
      >
        <NavLink to="/help-center" activeClassName="active">
          <HelpIcon size="18" className="icon-insert-chart" />
          <span className="name">Help Center</span>
        </NavLink>
      </li>
    </ul>
  );
};

export default VGGUserMenuComponent;



// WEBPACK FOOTER //
// ./src/shared/components/nav/menu/vgg_user.js